module.exports = __webpack_public_path__ + "static/media/slider-2.5dc00ac6.jpg";